import React from "react";
import ReportSummary from "../components/dashboard/ReportSummary";
import { useSolrLoaderQueueSize } from "../creator-application/searchServices";
import ReportLoadingIndicator from "../components/dashboard/ReportLoadingIndicator";

const SolrLoaderReport = () => {
  const results = useSolrLoaderQueueSize();

  if (results.isLoading) {
    return <ReportLoadingIndicator />;
  }
  return (
    <ReportSummary
      primary="Solr Loader Queue"
      secondary="Media currently being reloaded in solr"
      count={results.data.size}
    />
  );
};

export default SolrLoaderReport;
